import './App.css';
// import Header from './components/header/Header';
// import Menu from './components/menu/Menu';
// import MobileMenu from './components/mobile_tabmennu/MobileMenu';
// import Footer from './components/footer/Footer';
// import ProjectElements from './components/projectcontainer/ProjectElement';
import {BrowserRouter, Routes, Route} from 'react-router-dom'
// import ProjectsPage from './Pages/project/Project';
import Service from './pages/service/Service';
import ServiceDetailComponents from './pages/service/servicedetailcomponents/servicedetailcomponents';
import ContactUs from './pages/contactus/Contactus';
// import Home from './Pages/home/Home'
import Homemine from './pages/home/Homemine'
import Clients from './pages/clients/Clients';
// import ProjectDetailsComponent from './pages/project/projectdetailscomponent/ProjectDetailsComponent';
function App() {

  window.scroll({top:2500,left:0, behavior:'smooth'})
  
  return (
    <BrowserRouter>
      <Routes>
          {/* <Route path="/projects" element={<ProjectsPage />} /> */}
          <Route path="/" element={<Homemine />} />
          <Route path="/service" element={<Service />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/readmore" element={<ServiceDetailComponents />} />
          {/* <Route path="/projects/viewmore" element={<ProjectDetailsComponent />} /> */}
          <Route path="/contactus" element={<ContactUs/>} />
         
          {/* <Route path="*" element={<NoPage />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
